import React, { useState } from 'react';
import VideoHistory from './VideoHistory';

const VideoHistoryPopup: React.FC = () => {
  const [showVideoHistory, setShowVideoHistory] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowVideoHistory(true)}
        className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg hover:from-purple-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-purple-500 shadow-md hover:shadow-lg transition-all duration-200"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <span>My Videos</span>
      </button>

      {showVideoHistory && (
        <VideoHistory onClose={() => setShowVideoHistory(false)} />
      )}
    </>
  );
};

export default VideoHistoryPopup;
